import { services2 } from '/api/services2';

export const traitsService = services2.appTraitsService;
export const traitsServiceName = traitsService.getClassName();

// the same names as the names of the methods in /common/scripts/definitions/script-hooks.d.ts
export const TRAITS_SAVE_HOOK_NAME = 'onTraitsSave';
